import { Empty, Pagination, Skeleton, Timeline } from 'antd'
import PartnerApiRepository from 'egi/repositories/PartnerApiRepository'
import React, { useEffect, useState } from 'react'
import { timeAsDayjs } from 'utils/time'
import { describeLog, IPartnerLog } from '../partnerApiCredentials'

const LIMIT = 5

export default function PartnerApiLogs ({ promoterId }: { promoterId: string }) {
  const [logs, setLogs] = useState<IPartnerLog[]>([])
  const [totalDocs, setTotalDocs] = useState(0)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>()

  useEffect(() => {
    let cancelled = false
    const getLogs = async () => {
      setLoading(true)
      setError(undefined)
      try {
        const response = await PartnerApiRepository.logs(promoterId, { params: { page, limit: LIMIT } })
        if (cancelled) return
        setLogs(response.data.data?.logs?.docs ?? [])
        setTotalDocs(response.data.data?.logs?.totalDocs ?? 0)
      } catch (err) {
        if (!cancelled) setError(err.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    getLogs()

    return () => {
      cancelled = true
    }
  }, [promoterId, page])

  if (loading) return <Skeleton />
  if (error) return <Empty description={error} />
  if (!logs.length) return <Empty description="Nenhuma alteração registrada" />

  return (
    <>
      <Timeline>
        {logs.map(log => (
          <Timeline.Item key={log._id}>
            <small>{timeAsDayjs(log.createdAt).format('DD/MM/YYYY HH:mm')}</small>
            {describeLog(log).map((phrase, index) => <p key={`${index}-${phrase}`} className="font-500">{phrase}</p>)}
            <small>{log.modifiedBy?.name}</small>
          </Timeline.Item>
        ))}
      </Timeline>

      <Pagination current={page} pageSize={LIMIT} total={totalDocs} onChange={setPage} />
    </>
  )
}
